import { useMemo } from 'react';
import { useGetOrgsListQuery } from "../../../../../services/org/org-service";
export const useOrgNameMap = ({ skip = false }) => {
    const { data, loading: orgsListLoading } = useGetOrgsListQuery({
        sort: 'DEFAULT',
        sortascending: true,
        batchsize: -1,
        offset: 0,
        pattern: '',
    }, skip);
    const orgNameMap = useMemo(() => {
        const orgs = data?.Data?.orgs ?? [];
        return Object.fromEntries(orgs.map((org) => [org.orgId, org.orgName]));
    }, [data]);
    return { orgNameMap, orgsListLoading };
};
//# sourceMappingURL=useOrgNameMap.js.map